<div>
  <cap-haengige-geschaefte-auftraege
    [hasRight]="hasRight"
    [loadOption]="loadOption"
    [perimeter]="grundstueckIds"
    [showAuftraege]="false"
    class="haengige-geschaefte">
  </cap-haengige-geschaefte-auftraege>
</div>
